import { Link, Box, Colors, Text } from '@origin-digital/style-guide';
import * as React from 'react';

import { NavItemProps } from './NavItems.types';
import { SolarIcon } from '../SolarIcon';

const Wrapper = Box.extend`
  border: solid 1px
    ${(props: { type: string; view: string }) => (props.type === props.view ? Colors.LIGHT_ORANGE : Colors.GREY16)};
  cursor: pointer;
`;

const NavItem: React.StatelessComponent<NavItemProps> = ({ 'data-id': dataId, onChange, iconType, text, type, view }: NavItemProps) => {
  return (
    <Link componentType={'link'} data-id={dataId} onClick={() => onChange(type)}>
      <Wrapper
        type={type}
        view={view}
        paddingX={4}
        paddingY={6}
        display={'flex'}
        direction={'column'}
        alignItems={'center'}
        marginLeft={2}
        marginRight={2}
      >
        <Box marginBottom={2}>
          <SolarIcon size={35} iconType={iconType} />
        </Box>
        <Text size={'md'} align={'center'}>
          {text}
        </Text>
      </Wrapper>
    </Link>
  );
};

export { NavItem as default };
